import { RootState } from '../types'

export const getMainProductSelector = (state: RootState) => state.product
export const getProductsSelector = (state: RootState) => state.product.products
